import { ChangeDetectorRef, Component, ViewChild,ElementRef  } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { t } from '@fullcalendar/core/internal-common';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';

@Component({
  selector: 'app-user-account',
  templateUrl: './user-account.component.html',
  styleUrls: ['./user-account.component.scss']
})
export class UserAccountComponent {
  public userAccount!: FormGroup;
  public userInfo !: any;
  public file: File | null = null;
  public imagePath: any;
  public profilePicture!:any;
  @ViewChild('fileInput') fileInput!: ElementRef;
  constructor(private formBuilder: FormBuilder, private appService: AppService, private commonService: CommonService,private cd:ChangeDetectorRef,
    private userService: UserManagementService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.userAccount = this.formBuilder.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      company_name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email, Validators.minLength(3),
      Validators.maxLength(100)]],
      phone_number: ['', Validators.pattern('^[0-9]*$')],
      website_url: [''],
      about_us: [''],
      profile_picture: ['']
    });

    if (this.appService.getData('training-portal.userInfo')) {
      this.userInfo = JSON.parse(this.appService.getData('training-portal.userInfo'))
      if (this.userInfo.group_type == "company") {
        delete this.userAccount.controls['first_name'];
        delete this.userAccount.controls['last_name'];
      }
      else{
        delete this.userAccount.controls['company_name'];
        delete this.userAccount.controls['website_url'];
        delete this.userAccount.controls['about_us'];
      }
    }
    for(let [key,value] of Object.entries(this.userInfo)){
      for(let [fkey,fvalue] of Object.entries(this.userAccount.value)){
        if(key==fkey && fkey!="profile_picture"){
          this.userAccount.get(fkey)?.setValue(value)
        }
      }
    }
    if(this.userInfo.company_logo && this.userInfo.group_type == "company"){
      this.profilePicture=this.userInfo.company_logo
    }
    else{
      this.profilePicture=this.userInfo.profile_picture
    }
  }
  onProfilePicChange(event: any) {
    const selectedFile: File = event.target.files[0];

     if (selectedFile) {
      this.file = selectedFile;

    //   // Use FileReader to read and display the preview
      const reader = new FileReader();
      reader.readAsDataURL(this.file);
      reader.onload = () => {
      this.imagePath = reader.result;
      };
    //   reader.readAsDataURL(selectedFile);
   }
  }
  onSubmit() {
    if (this.userAccount.valid) {
      let data = {
        group_type: this.userInfo.group_type,
      }
      data = Object.assign(data, this.userAccount.value)
      let formData=new FormData()
      formData=this.commonService.convertToFormData(data)
      formData.delete('profile_picture')
      let item:any;
      item=this.file
      if(this.userInfo.group_type=='company'){
        formData.append('company_logo',item)
      }
      else{
        formData.append('profile_picture',item)
      }
      this.spinner.show();
      this.userService.editUserProfile(formData).subscribe({
        next: (success: Object) => {
          this.spinner.hide();
          // this.myApp.successToast(success.msg);
          if (success["status"] == 200) {
            this.appService.showToastMessage("success", success["msg"]);
            localStorage.setItem('training-portal.userInfo', JSON.stringify(success["data"]));
          }
        },
        error: (error: any) => {
          this.spinner.hide();
          this.commonService.handleError(error);
        },
      });

    } else {
      this.userAccount.markAllAsTouched()
    }
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(this.userAccount, controlName, validationType);
  }
}
